<template lang="html">
    <div class="col-sm-12">

        <div class="form-group row">

            <!-- Name -->
            <div class="col-sm-12" :class="{ error: $v.scheduleTask.name.$error }">
                <h5>Name</h5>
                <div class="row">
                    <div class="col-sm-6">
                        <input type="text" class="w-100" v-model="scheduleTask.name" @input="$v.scheduleTask.name.$touch">
                        <div v-if="$v.scheduleTask.name.$error" class="messages">
                            <span v-if="!$v.scheduleTask.name.required">Name is required.</span>
                            <span v-if="!$v.scheduleTask.name.minLength">Name must have at least 4 characters.</span>
                            <span v-if="!$v.scheduleTask.name.maxLength">Name should have 35 characters or less.</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Type -->
            <div class="col-sm-12 mt-4">
                <h5>Task type</h5>
                <div class="row">
                    <div class="col-sm-6">
                        <v-select :disabled="editMode" :options="typeOptions" v-model="selectedType" @input="typeChanged"></v-select>
                    </div>
                </div>
            </div>

            <!-- Details -->
            <div class="col-sm-12 mt-4">
                <h5>Details</h5>
                <form-part-invoice :scheduleTask="scheduleTask" />
            </div>

            <!-- Repetition -->
            <div class="col-sm-12 mt-4">
                <h5>Start Date and Repetition</h5>
                <cron-configure :cron.sync="scheduleTask.cron" :startDate.sync="scheduleTask.periodStart" :disabledSTartDate="editMode" />
            </div>

            <!-- Type -->
            <div class="col-sm-12 mt-4">
                <h5>Task completed notification</h5>
                <div class="row">
                    <div class="col-sm-12">
                        <label class="full">
                            <span>Email</span> <span class="normal fs-smaller">(you can enter multiple emails by separating them with comma ",")</span>
                            <input type="text" class="bg-lighter" v-model="scheduleTask.emailListToSendResume" placeholder="email1@domain.com, email2@domain.com, email3@domain.com">
                        </label>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import vSelect from 'vue-select'
import {mapActions, mapGetters} from 'vuex'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'

// Specific form parts
import formPartInvoice from './typeSpecific/formPartInvoice'
import cronConfigure from './cronConfigure'

export default {
    mounted: function () {
        // emit validation status so that parent component knows if the form is valid
        this.$emit('validationChanged', this.$v.$invalid)
    },
    data: function () {
        return {
            selectedType: {
                label: 'Invoice',
                id: 1
            }
        }
    },
    props: {
        scheduleTask:{
            type: Object
        },
        editMode:{
            type: Boolean,
            default: false
        }
    },
    validations: {
        scheduleTask: {
            name: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(20)
            },
        },
    },
    computed: {
        ...mapGetters([
            'getTypeOptions'
        ]),
        typeOptions: function () {
            return this.getTypeOptions
        }
    },
    methods: {
        typeChanged: function (e) {
            this.scheduleTask.type = e.id
        }
    },
    watch: {
        '$v': {
            deep: true,

            handler: function (newVal, oldVal) {
                this.$emit('validationChanged', newVal.$invalid)
            }
        }
    },
    components: {
        vSelect,
        formPartInvoice,
        cronConfigure
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// scheduleTaskForm.vue?067c54fc